import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {SearchAutoCompleteParam} from '../../common/shared/api/nicolas/params/SearchAutoCompleteParam.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {SearchAutoCompleteVo} from '../../common/shared/api/nicolas/vo/SearchAutoCompleteVo.interface';

/**
 * 검색 자동완성 (V2)
 *
 * V2에서는 세트상품 타이틀도 자동완성 후보에 포함되며, page 파라미터 및
 * total_count/is_end 페이지네이션 필드를 제공한다.
 * 참고: https://kakaoent.atlassian.net/wiki/spaces/PSD/pages/5044568674
 *
 * Origin: pageNicolasApi.getSearchAutoComplete
 * API: GET /api/v2/search/autocomplete
 */
export async function getSearchAutocomplete(
  params: SearchAutoCompleteParam,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SearchAutoCompleteVo}> {
  const {keyword, page = 0, size = 10} = params;

  const response = await axiosBffFetch(
    '/api/gateway/api/v2/search/autocomplete',
    {
      method: 'GET',
      params: {keyword, page, size},
    },
    options
  );

  return response.data;
}
